export default {
  create_title: 'Adicionar endpoint de webhook',
  edit_title: 'Editar endpoint de webhook',
  form: {
    url: 'URL do endpoint HTTPS',
    description: 'Descrição',
    description_placeholder: 'ex.: Eventos de encomendas para o POS',
    events: 'Eventos a entregar',
    events_required: 'Selecione pelo menos um evento.',
    events_hint: 'Apenas os eventos selecionados são enviados para este endpoint.',
    events_selected: '{{selected}} de {{total}}',
    event_groups: {
      order: 'Encomendas',
      store: 'Loja',
      product: 'Produtos',
      modifier: 'Modificadores',
      menu_push: 'Envios de menu',
      payout: 'Pagamentos',
    },
    status: 'Estado',
    status_active: 'Ativo',
    status_disabled: 'Desativado',
    status_auto_disabled: 'Desativado automaticamente (escolha Ativo para reativar)',
  },
  buttons: {
    cancel: 'Cancelar',
    create: 'Criar',
    save: 'Guardar',
  },
  toasts: {
    created: 'Endpoint criado.',
    updated: 'Endpoint atualizado.',
    error: 'Não foi possível guardar o endpoint. Tente novamente.',
  },
};
